// test679
(679 && 0);
